const SAVE_SUMMARY_BASE_ROUTE = '/save_summary';

export const SAVE_SUMMARY_API_ROUTES = {
  v2_index: () => `${SAVE_SUMMARY_BASE_ROUTE}/v2`,
  v2_config: () => `${SAVE_SUMMARY_BASE_ROUTE}/config/v2`,
  status: () => `${SAVE_SUMMARY_BASE_ROUTE}/status`,
} as const;
